



























import {Vue, Component, Prop} from 'vue-property-decorator'
import {State} from 'vuex-class'
import {Pos, ReservationResponse, VehicleSlot} from '@/lib/kepler/interfaces'
import ServiceMesh from '@/lib/serviceMesh'
import Utils from '@/utils'

@Component({
  components: {
    Button: Utils.loadComponent('Button'),
    Icon: Utils.loadComponent('proxy/Icon'),
    Accordion: Utils.loadComponent('proxy/Accordion/Accordion'),
    AccordionContent: Utils.loadComponent('proxy/Accordion/AccordionContent'),
    Container: Utils.loadComponent('proxy/Container'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Divider: Utils.loadComponent('proxy/Divider'),
    VehicleLocation: Utils.loadComponent('entities/vehicle/VehicleLocation'),
    Img: Utils.loadComponent('proxy/Image'),
  },
  name: 'VehicleLotAndDistance',
})
export default class VehicleLotAndDistance extends Vue {
  @State((state) => state.profile.userPosition) public userPosition!: Pos | null

  @Prop() public vehicleSlot!: VehicleSlot
  @Prop() public reservation?: ReservationResponse
  @Prop({type: Boolean, default: true}) public hasLocation?: boolean

  protected get vehicleTypeColor() {
    const key = `${this.vehicleSlot.reservation_type}${this.vehicleSlot.vehicle.category.type}`.toUpperCase()
    return {color: ServiceMesh.colors[key]}
  }
  protected get image() {
    return this.vehicleSlot.lot.picture.includes('404') ? false : this.vehicleSlot.lot.picture
  }
  protected get distanceString() {
    const d: number | null = this.vehicleSlot.distance
    if (d !== null) {
      const str = this.$t('common.circa')
      if (this.$distance().toLowerCase() === 'km') {
        return str  + ' ' + (d >= 1000 ? this.$distance(Math.round((d / 1000) * 10) / 10) : Math.floor(d) + 'm')
      } else {
        return str + ' ' + this.$distance(Math.round(d))
      }
    } else {
      // TODO: translate
      return false
    }
  }

  protected get destination() {
    const vehicleSlot = this.reservation?.vehicle_slot || this.vehicleSlot || null
    const position = this.reservation?.current_vehicle_position || vehicleSlot?.position
    if (position) {
      return {lat: position.latitude, lng: position.longitude, acc: null}
    }
  }

  protected openInMaps() {
    if (this.userPosition && this.destination) {
      const origin = `&origin=${this.userPosition.lat},${this.userPosition.lng}`
      const destination = `&destination=${this.destination.lat},${this.destination.lng}`
      const url = `https://www.google.com/maps/dir/?api=1${origin + destination}&=travelmode=walking`
      cordova.InAppBrowser.open(url, '_system')
    }
  }
}
